import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next';
import {
    Row, Col, Button, Label,
    Card, CardHeader, CardBody,
    CardImg, CardImgOverlay,
    CardFooter, CardTitle, CardText
} from 'reactstrap';
import { Link } from 'react-router-dom';
import { Div, StudentListItem } from '../../../components';
import { matchSorter } from 'match-sorter';
import { UncontrolledCarousel } from 'reactstrap';
import './PublicDashboard.css';
import { loadPosts } from '../../../redux';
import Icon from '@mdi/react';
import { mdiEyeArrowRightOutline, mdiAccountArrowRightOutline, mdiAccountSearchOutline, mdiClose } from '@mdi/js';
import Masonry from 'react-masonry-css';

const Dashboard = props => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const { posts } = useSelector(state => state.posts);

    useEffect(() => {
        dispatch(loadPosts({
            'categories': 9, // pole-education
            'per_page': 2,
            '_embed' : true
        }));
    }, [])

    const breakpointColumnsObj = {
        default: 3,
        1980: 2,
        1400: 2,
        1200: 2,
        992: 2,
        768: 1,
        576: 1
    };

    return (
        <div className="PublicDashboard">
            <Row>
                <Col>
                    <Card color="dark" inverse>
                        <CardBody>
                            <CardTitle tag="h3" className="mb-2">
                                { t('dashboard.contact_us_title') }
                            </CardTitle>
                            <CardText className="mb-2">
                                { t('dashboard.contact_us_text') }
                                <div>
                                    <b>education@annecy-mosquee.com</b>
                                </div>
                            </CardText>
                        </CardBody>
                    </Card>
                    <br/>
                    <Card>
                        <CardBody>
                            <CardTitle tag="h3" className="mb-2">
                                { t('dashboard.last_news') }
                            </CardTitle>
                            <Masonry
                                breakpointCols={breakpointColumnsObj}
                                className="masonry-grid"
                                columnClassName="masonry-grid_column"
                            >
                                {posts?.map(post => (
                                    <Div key={post.id}>
                                        {(width, height) => (
                                            <Card key={post.id} className="post-card mb-3">
                                                <CardImg
                                                    alt={post.getTitle()}
                                                    src={post.getFeaturedMediaUrl('large')}
                                                    width="100%"
                                                />
                                                <CardBody>
                                                    <CardTitle tag="h1">
                                                        {post.getTitle()}
                                                    </CardTitle>
                                                    <CardText dangerouslySetInnerHTML={{__html: post.getContent()}} />
                                                    <CardText>
                                                        <small>
                                                            <em>{post.getFormattedDate()}</em>
                                                        </small>
                                                    </CardText>
                                                </CardBody>
                                            </Card>
                                        )}
                                    </Div>
                                ))}
                            </Masonry>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    );
}

export default Dashboard;
